import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"
import { inputClasses } from "@mui/material"

export const useStyles = makeStyles<{
  multiple: boolean
}>()(({ spacing, typography }, { multiple }) => ({
  autocompleteContainer: {
    [`& .${inputClasses.root}`]: {
      borderRadius: "3px",
      padding: multiple ? spacing(4, 2, 2) : spacing(4, 2, 2, 4)
    }
  },
  groupLabel: {
    padding: spacing(2, 3),
    fontSize: typography.body2.fontSize,
    lineHeight: typography.body2.lineHeight,
    color: blueGrey[800]
  },
  container: {
    borderBottom: `1px solid ${blueGrey[100]}`,
    marginBottom: spacing(1)
  }
}))
